import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";





@Component({
  selector: 'printer-sunmi-info',
  templateUrl: 'printer-sunmi-info.html',
})
export class PrinterSunmiInfoPage {


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals) {

  }
}



// WEBPACK FOOTER //
// ./src/pages/printer-sunmi/printer-sunmi-info/printer-sunmi-info.ts